<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>口语题库</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="题头 ID">
              <Input v-model="queryParam.id" placeholder="题头主键，精确匹配"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="业务键">
              <Input v-model="queryParam.businessCode" placeholder="如 L1-L-U1-LR-Q001"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="级别">
              <Select v-model="queryParam.levelCode" clearable placeholder="请选择级别">
                <Option v-for="lv in levels" :value="lv" :key="lv">{{lv}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="题型">
              <Select v-model="queryParam.questionType" filterable clearable placeholder="请选择题型">
                <Option v-for="t in questionTypes" :value="t" :key="t">{{questionTypeLabel(t, 'Speaking')}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="状态">
              <Select v-model="queryParam.status" clearable placeholder="请选择状态">
                <Option value="PENDING_REVIEW">待审核 PENDING_REVIEW</Option>
                <Option value="ONLINE">已上线 ONLINE</Option>
                <Option value="OFFLINE">已下线 OFFLINE</Option>
                <Option value="DISCARDED">已废弃 DISCARDED</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="场景">
              <Select v-model="queryParam.examScene" clearable placeholder="请选择场景">
                <Option value="GENERAL">通用 GENERAL</Option>
                <Option value="PLACEMENT_ONLY">仅入门测 PLACEMENT_ONLY</Option>
                <Option value="SUMMATIVE_ONLY">仅阶段测 SUMMATIVE_ONLY</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" @click="search">搜索</Button>
          <Button type="warning" @click="openBatch">批量编辑</Button>
          <Button type="success" @click="openCreate">新建</Button>
          <Button @click="triggerImport">导入口语</Button>
          <Button @click="downloadTemplate">下载模板</Button>
          <input type="file" ref="fileInput" accept=".xls,.xlsx" style="display:none" @change="importData">
        </div>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/mex/speak/questions/list"
          :params="queryParam" :onLoading="onLoading" :reload="reload" @on-selection-change="selectionChange"></List>
    <MexQuestionBatchModal v-model="batchVisible" bank="speak" :selected-rows="selection"
                           @success="search"></MexQuestionBatchModal>
    <Modal v-model="editVisible" title="编辑口语题" width="960">
      <p>业务键 {{businessCode}} / 版本 {{form.versionNo}} / {{statusLabel(form.status)}}</p>
      <div style="max-height:70vh;overflow-y:auto;padding-right:8px">
      <Form :label-width="130">
        <Form-item v-if="createMode" label="业务键">
          <Input v-model="businessCode" placeholder="如 L1-L-U1-LR-Q001"></Input>
        </Form-item>
        <Form-item v-if="!createMode && versions.length" label="历史版本">
          <Select v-model="selectedVersionId" @on-change="switchVersion">
            <Option v-for="v in versions" :value="v.id" :key="v.id">{{v.versionNo}} / {{statusLabel(v.status)}}</Option>
          </Select>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="8">
            <Form-item label="技能">
              <Select v-model="form.skill" transfer>
                <Option value="Speaking">口语 Speaking</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="级别">
              <Input v-model="form.levelCode" placeholder="如 L1.0"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="题型">
              <Select v-model="form.questionType" filterable transfer placeholder="检索已有题型">
                <Option v-for="t in editTypeOptions" :value="t.value" :key="t.value">{{t.label}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="场景">
              <Select v-model="form.examScene">
                <Option value="GENERAL">通用 GENERAL</Option>
                <Option value="PLACEMENT_ONLY">仅入门测 PLACEMENT_ONLY</Option>
                <Option value="SUMMATIVE_ONLY">仅阶段测 SUMMATIVE_ONLY</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="子技能英文">
              <Select v-model="form.subSkillEn" filterable clearable transfer placeholder="选择题库已有子技能"
                      @on-change="onSubSkillEnChange">
                <Option v-for="t in subSkillEnOptions" :value="t.value" :key="'en-' + t.value">{{t.label}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="子技能中文">
              <Select v-model="form.subSkillCn" filterable clearable transfer placeholder="选择题库已有子技能"
                      @on-change="onSubSkillCnChange">
                <Option v-for="t in subSkillCnOptions" :value="t.value" :key="'cn-' + t.value">{{t.label}}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="交互类型">
              <Input v-model="form.interactionType" placeholder="如 speak / record，可空"></Input>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="中文指令">
          <Input v-model="form.instructionCn" placeholder="给孩子看的中文指令"></Input>
        </Form-item>
        <Form-item label="英文指令">
          <Input v-model="form.instructionEn" placeholder="给孩子看的英文指令"></Input>
        </Form-item>
        <Form-item label="题干脚本">
          <Input v-model="form.script" type="textarea" :rows="2" placeholder="口语题干脚本，可空"></Input>
        </Form-item>
        <Form-item label="题干">
          <Input v-model="form.stem" type="textarea" :rows="3" placeholder="题目正文"></Input>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="12">
            <Form-item label="题干音频">
              <Input v-model="form.stemAudio" placeholder="音频地址，可空"></Input>
              <MexAssetPreview :path="form.stemAudio" :skill="form.skill || 'Speaking'" bank="speak" accept="audio/*"
                               @input="form.stemAudio = $event"></MexAssetPreview>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="题干图">
              <Input v-model="form.stemImage" placeholder="图片地址，可空"></Input>
              <MexAssetPreview :path="form.stemImage" :skill="form.skill || 'Speaking'" bank="speak" accept="image/*"
                               @input="form.stemImage = $event"></MexAssetPreview>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="示范音频">
          <Input v-model="form.answerAudioSample" placeholder="标准作答音频地址，可空"></Input>
          <MexAssetPreview :path="form.answerAudioSample" :skill="form.skill || 'Speaking'" bank="speak" accept="audio/*"
                           @input="form.answerAudioSample = $event"></MexAssetPreview>
        </Form-item>
        <Form-item label="答案/跟读文本">
          <Input v-model="form.answerKey" type="textarea" :rows="2" placeholder="跟读或标准作答文本，如 apple"></Input>
        </Form-item>
        <Form-item label="完整参考作答">
          <Input v-model="form.referenceAnswerFull" type="textarea" :rows="2" placeholder="完整示范答案，可空"></Input>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="8">
            <Form-item label="满分">
              <Input v-model="form.fullScore" placeholder="单题满分，如 2"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="星级">
              <Input v-model="form.difficultyLevel" placeholder="1-5 星"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="抽题权重">
              <Input v-model="form.adaptiveWeight" placeholder="现稿多为 0.5"></Input>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="评分维度">
          <p class="mex-dim-hint">口语 AI 三维权重，建议合计 100。空着保存时按准确 40 / 流利 30 / 完整 30。</p>
          <div class="mex-dim-card">
            <Form :show-message="false" label-position="top">
              <Row :gutter="12">
                <i-col :span="8" v-for="d in dimensions" :key="d.key">
                  <Form-item :label="dimLabel(d.key)">
                    <Input-number v-model="d.weight" :min="0" :max="100" placeholder="百分数，如 40" style="width:100%"></Input-number>
                  </Form-item>
                </i-col>
              </Row>
            </Form>
            <p class="mex-dim-hint">当前合计 {{dimSum}}</p>
          </div>
        </Form-item>
        <Form-item label="评分细则">
          <Input v-model="form.scoringRubric" type="textarea" :rows="2" placeholder="口语评分细则，可空"></Input>
        </Form-item>
        <Form-item label="AI基准">
          <Input v-model="form.aiBenchmark" type="textarea" :rows="2" placeholder="音素/语速等 AI 评分基准，可空"></Input>
        </Form-item>
        <Form-item label="解析">
          <Input v-model="form.explanation" type="textarea" :rows="2" placeholder="解析文案，可空"></Input>
        </Form-item>
        <Form-item label="考点">
          <Input v-model="form.examPoint" type="textarea" :rows="2" placeholder="考查点，可空"></Input>
        </Form-item>
        <Form-item label="备注">
          <Input v-model="form.remark" type="textarea" :rows="2" placeholder="内部备注，可空"></Input>
        </Form-item>
        <Form-item label="常见错误">
          <Input v-model="form.commonMistakes" type="textarea" :rows="2" placeholder="常见错误说明，可空"></Input>
        </Form-item>
        <Form-item label="知识点">
          <Input v-model="form.knowledgePointHierarchy" placeholder="知识点路径，可空"></Input>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="8">
            <Form-item label="能力编码">
              <Input v-model="form.abilityDimensionCode" placeholder="如 SPE-01"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="能力档">
              <Input v-model="form.scoreMappingLevel" placeholder="内部能力档，可空"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="课程单元">
              <Input v-model="form.courseUnitMapping" placeholder="对应课程单元，可空"></Input>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="能力描述">
          <Input v-model="form.abilityDescription" type="textarea" :rows="2" placeholder="报告用的能力描述，可空"></Input>
        </Form-item>
        <Row :gutter="12">
          <i-col :span="12">
            <Form-item label="全国均分">
              <Input v-model="form.benchmarkNationalAvg" placeholder="如 72.5，可空"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="同城优秀均分">
              <Input v-model="form.benchmarkCityExcellentAvg" placeholder="如 85，可空"></Input>
            </Form-item>
          </i-col>
        </Row>
        <Form-item label="提升建议">
          <Input v-model="form.improvementSuggestion" type="textarea" :rows="2" placeholder="报告提升建议，可空"></Input>
        </Form-item>
        <Form-item label="练习推荐">
          <Input v-model="form.recommendedPractice" placeholder="推荐练习，可空"></Input>
        </Form-item>
        <Form-item label="前置知识">
          <Input v-model="form.prerequisiteKnowledge" placeholder="前置知识，可空"></Input>
        </Form-item>
        <Form-item label="掌握周期">
          <Input v-model="form.learningCycle" placeholder="如 1-2周，可空"></Input>
        </Form-item>
      </Form>
      </div>
      <div slot="footer">
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" @click="saveEdit">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import MexQuestionBatchModal from './MexQuestionBatchModal'
import MexAssetPreview from './MexAssetPreview'
import { questionTypeLabel } from './mex-question-type'

export default {
  name: 'MexSpeakQuestionList',
  components: { MexQuestionBatchModal, MexAssetPreview },
  data () {
    return {
      searchLoading: false,
      reload: 0,
      batchVisible: false,
      selection: [],
      editVisible: false,
      createMode: false,
      businessCode: '',
      selectedVersionId: null,
      versions: [],
      form: {},
      dimensions: [],
      queryParam: {},
      questionTypes: [],
      editQuestionTypes: [],
      editSubSkills: [],
      skipSubSkillSync: false,
      levels: ['L1.0', 'L2.0', 'L3.0', 'L4.0', 'L5.0', 'L6.0', 'L7.0', 'L8.0'],
      tableColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '版本 ID', key: 'currentVersionId', width: 90, ellipsis: true },
        { title: '题头 ID', key: 'id', width: 80, ellipsis: true },
        { title: '业务键', key: 'businessCode', width: 200, ellipsis: true },
        { title: '级别', key: 'levelCode', width: 80, ellipsis: true },
        { title: '题型', key: 'questionType', width: 280, ellipsis: true, render: (h, p) => h('span', questionTypeLabel(p.row.questionType, 'Speaking')) },
        { title: '版本', key: 'versionNo', width: 80, ellipsis: true },
        { title: '状态', key: 'status', width: 200, ellipsis: true, render: (h, params) => h('span', this.statusLabel(params.row.status)) },
        { title: '场景', key: 'examScene', width: 220, ellipsis: true, render: (h, params) => h('span', this.examSceneLabel(params.row.examScene)) },
        { title: '曝光', key: 'exposureCount', width: 70, ellipsis: true },
        { title: '通过率', key: 'passRate', width: 80, ellipsis: true },
        { title: '题干', key: 'stem', width: 240, render: (h, p) => this.renderStem(h, p.row.stem) },
        {
          title: '操作',
          key: 'action',
          width: 300,
          render: (h, params) => {
            return h('div', { style: { whiteSpace: 'nowrap' } }, [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.openEdit(params.row) }
              }, '编辑'),
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.changeStatus(params.row, 'online') }
              }, '上线'),
              h('Button', {
                props: { size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.changeStatus(params.row, 'offline') }
              }, '下线'),
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: { click: () => this.discard(params.row) }
              }, '废弃')
            ])
          }
        }
      ]
    }
  },
  computed: {
    dimSum () {
      let n = 0
      this.dimensions.forEach(item => {
        n += Number(item.weight) || 0
      })
      return n
    },
    editTypeOptions () {
      let list = []
      let seen = {}
      ;(this.editQuestionTypes || []).forEach(t => {
        if (!t || seen[t]) return
        seen[t] = true
        list.push({ value: t, label: questionTypeLabel(t, 'Speaking') })
      })
      let cur = this.form && this.form.questionType
      if (cur && !seen[cur]) {
        list.unshift({ value: cur, label: questionTypeLabel(cur, 'Speaking') })
      }
      return list
    },
    subSkillEnOptions () {
      return this.buildSubSkillOptions('en')
    },
    subSkillCnOptions () {
      return this.buildSubSkillOptions('cn')
    }
  },
  created () {
    this.loadQuestionTypes()
  },
  methods: {
    questionTypeLabel,
    renderStem (h, stem) {
      let text = stem || ''
      if (!text) return h('span', '—')
      return h('Poptip', {
        props: { trigger: 'click', transfer: true, placement: 'bottom', width: 480, wordWrap: true }
      }, [
        h('a', {
          style: {
            display: 'inline-block',
            maxWidth: '220px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            verticalAlign: 'bottom'
          }
        }, text),
        h('div', {
          slot: 'content',
          style: {
            maxHeight: '360px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            lineHeight: '22px'
          }
        }, text)
      ])
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    loadQuestionTypes () {
      this.$http.post('/mex/speak/questions/types').then(res => {
        this.questionTypes = res.status === 'ok' ? (res.data || []) : []
      }).catch(() => {
        this.questionTypes = []
      })
    },
    loadEditQuestionTypes () {
      this.$http.post('/mex/speak/questions/types').then(res => {
        this.editQuestionTypes = res.status === 'ok' ? (res.data || []) : []
      }).catch(() => {
        this.editQuestionTypes = []
      })
    },
    loadEditSubSkills () {
      this.$http.post('/mex/speak/questions/sub-skills').then(res => {
        this.editSubSkills = res.status === 'ok' ? (res.data || []) : []
      }).catch(() => {
        this.editSubSkills = []
      })
    },
    buildSubSkillOptions (field) {
      let list = []
      let seen = {}
      ;(this.editSubSkills || []).forEach(item => {
        let value = field === 'en' ? item.en : item.cn
        if (!value || seen[value]) return
        seen[value] = true
        list.push({ value: value, label: value })
      })
      let cur = field === 'en' ? this.form.subSkillEn : this.form.subSkillCn
      if (cur && !seen[cur]) {
        list.unshift({ value: cur, label: cur })
      }
      return list
    },
    findSubSkillBy (field, value) {
      if (!value) return null
      let rows = this.editSubSkills || []
      for (let i = 0; i < rows.length; i++) {
        if ((field === 'en' ? rows[i].en : rows[i].cn) === value) {
          return rows[i]
        }
      }
      return null
    },
    onSubSkillEnChange (en) {
      if (this.skipSubSkillSync) return
      let pair = this.findSubSkillBy('en', en)
      if (pair && pair.cn && this.form.subSkillCn !== pair.cn) {
        this.skipSubSkillSync = true
        this.form.subSkillCn = pair.cn
        this.$nextTick(() => {
          this.skipSubSkillSync = false
        })
      }
    },
    onSubSkillCnChange (cn) {
      if (this.skipSubSkillSync) return
      let pair = this.findSubSkillBy('cn', cn)
      if (pair && pair.en && this.form.subSkillEn !== pair.en) {
        this.skipSubSkillSync = true
        this.form.subSkillEn = pair.en
        this.$nextTick(() => {
          this.skipSubSkillSync = false
        })
      }
    },
    statusLabel (code) {
      if (code === 'PENDING_REVIEW') return '待审核 PENDING_REVIEW'
      if (code === 'ONLINE') return '已上线 ONLINE'
      if (code === 'OFFLINE') return '已下线 OFFLINE'
      if (code === 'DISCARDED') return '已废弃 DISCARDED'
      return code || ''
    },
    examSceneLabel (code) {
      if (code === 'GENERAL') return '通用 GENERAL'
      if (code === 'PLACEMENT_ONLY') return '仅入门测 PLACEMENT_ONLY'
      if (code === 'SUMMATIVE_ONLY') return '仅阶段测 SUMMATIVE_ONLY'
      return code || ''
    },
    dimLabel (key) {
      if (key === 'accuracy') return '准确度'
      if (key === 'fluency') return '流利度'
      if (key === 'completeness') return '完整度'
      return key
    },
    defaultDimensions () {
      return [
        { key: 'accuracy', weight: 40 },
        { key: 'fluency', weight: 30 },
        { key: 'completeness', weight: 30 }
      ]
    },
    toPercent (val) {
      let n = Number(val)
      if (isNaN(n)) return 0
      if (n > 1) return n
      return Math.round(n * 1000) / 10
    },
    parseDimensions (raw) {
      if (!raw) return this.defaultDimensions()
      try {
        let obj = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (!obj || typeof obj !== 'object' || obj.length != null) {
          this.$Message.warning('原评分维度无法解析，已套用默认值')
          return this.defaultDimensions()
        }
        let defaults = this.defaultDimensions()
        let used = {}
        let list = defaults.map(item => {
          used[item.key] = true
          let val = obj[item.key]
          return {
            key: item.key,
            weight: val == null ? item.weight : this.toPercent(val)
          }
        })
        Object.keys(obj).forEach(key => {
          if (!used[key]) {
            list.push({ key: key, weight: this.toPercent(obj[key]) })
          }
        })
        return list
      } catch (e) {
        this.$Message.warning('原评分维度无法解析，已套用默认值')
        return this.defaultDimensions()
      }
    },
    stringifyDimensions () {
      let obj = {}
      this.dimensions.forEach(item => {
        if (item.key) {
          obj[item.key] = Math.round((Number(item.weight) || 0) * 10) / 1000
        }
      })
      return JSON.stringify(obj)
    },
    search () {
      this.selection = []
      this.reload = Date.now()
      this.$nextTick(() => {
        if (this.$refs.list) {
          this.$refs.list.search()
        }
      })
    },
    selectionChange (selection) {
      this.selection = selection || []
    },
    openBatch () {
      this.batchVisible = true
    },
    escapeHtml (s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    showImportResult (d) {
      let data = d || {}
      let msg = '导入成功 ' + (data.successCount || 0) + '，跳过 ' + (data.skipCount || 0) + '，失败 ' + (data.failCount || 0)
      let rows = data.failRows || []
      if (rows.length) {
        let body = rows.map(r => this.escapeHtml(r)).join('<br>')
        this.$Modal.warning({
          title: '导入结果',
          width: 720,
          content: this.escapeHtml(msg) + '<br><pre style="max-height:320px;overflow:auto;white-space:pre-wrap">' + body + '</pre>'
        })
      } else {
        this.$Message.success(msg)
      }
    },
    triggerImport () {
      this.$refs.fileInput.click()
    },
    downloadTemplate () {
      this.$http.get('/mex/speak/questions/template', { responseType: 'arraybuffer' }).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '口语题库导入模板.xlsx'
        link.click()
      }).catch(() => {
        this.$Message.error('模板下载失败')
      })
    },
    importData (event) {
      let file = event.target.files[0]
      if (!file) return
      let formData = new FormData()
      formData.append('file', file)
      this.$http.post('/mex/speak/questions/import', formData, { transformRequest: [] }).then(res => {
        if (res.status === 'ok') {
          this.showImportResult(res.data)
          this.loadQuestionTypes()
          this.search()
        } else {
          this.$Message.error(res.msg || '导入失败')
        }
        this.$refs.fileInput.value = ''
      }).catch(() => {
        this.$Message.error('导入失败')
        this.$refs.fileInput.value = ''
      })
    },
    openCreate () {
      this.createMode = true
      this.businessCode = ''
      this.versions = []
      this.selectedVersionId = null
      this.form = {
        skill: 'Speaking',
        levelCode: 'L1.0',
        examScene: 'GENERAL',
        questionType: '',
        stem: '',
        versionNo: 'v1.0',
        status: 'PENDING_REVIEW'
      }
      this.dimensions = this.defaultDimensions()
      this.editVisible = true
      this.loadEditQuestionTypes()
      this.loadEditSubSkills()
    },
    applyDetail (data) {
      this.businessCode = data.businessCode
      this.form = Object.assign({ skill: 'Speaking' }, data.speak || {})
      this.form.skill = 'Speaking'
      this.dimensions = this.parseDimensions(this.form.dimensionsJson)
      this.versions = data.versions || []
      this.selectedVersionId = this.form.id
      this.createMode = false
      this.editVisible = true
      this.loadEditQuestionTypes()
      this.loadEditSubSkills()
    },
    openEdit (row) {
      this.$http.post('/mex/speak/questions/detail', { versionId: row.currentVersionId }).then(res => {
        if (res.status === 'ok' && res.data && res.data.speak) {
          this.applyDetail(res.data)
        } else {
          this.$Message.error(res.msg || '加载失败')
        }
      })
    },
    switchVersion (versionId) {
      if (!versionId || versionId === this.form.id) return
      this.$http.post('/mex/speak/questions/detail', { versionId: versionId }).then(res => {
        if (res.status === 'ok' && res.data && res.data.speak) {
          this.applyDetail(res.data)
        } else {
          this.$Message.error(res.msg || '加载失败')
        }
      })
    },
    savePayload () {
      let payload = Object.assign({}, this.form)
      delete payload.gmtCreate
      delete payload.gmtModified
      delete payload.checksum
      return payload
    },
    saveEdit () {
      this.form.dimensionsJson = this.stringifyDimensions()
      if (this.createMode) {
        let payload = Object.assign({}, this.savePayload(), { businessCode: this.businessCode })
        this.$http.post('/mex/speak/questions/create', payload).then(res => {
          if (res.status === 'ok') {
            this.$Message.success('已新建，待审核上线')
            this.editVisible = false
            this.loadQuestionTypes()
            this.search()
          } else {
            this.$Message.error(res.msg || '保存失败')
          }
        })
        return
      }
      this.$http.post('/mex/speak/questions/save', this.savePayload()).then(res => {
        if (res.status === 'ok') {
          this.$Message.success(this.form.status === 'ONLINE' ? '已升版本，待审核上线' : '已保存')
          this.editVisible = false
          this.loadQuestionTypes()
          this.search()
        } else {
          this.$Message.error(res.msg || '保存失败')
        }
      })
    },
    changeStatus (row, action) {
      if (action === 'online') {
        this.$Modal.confirm({
          title: '确认上线',
          content: '上线该版本后，同一题目其它已上线版本会自动下线。',
          onOk: () => this.doChangeStatus(row, action)
        })
        return
      }
      this.doChangeStatus(row, action)
    },
    doChangeStatus (row, action) {
      this.$http.post('/mex/speak/questions/' + action, { versionId: row.currentVersionId }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('已更新')
          this.search()
        } else {
          this.$Message.error(res.msg || '操作失败')
        }
      })
    },
    discard (row) {
      this.$Modal.confirm({
        title: '废弃版本',
        content: '确认废弃该版本？已上线须先下线。不能回滚，只能再上线其它版本。',
        onOk: () => {
          this.$http.post('/mex/speak/questions/discard', { versionId: row.currentVersionId }).then(res => {
            if (res.status === 'ok') {
              this.$Message.success('已废弃')
              this.search()
            } else {
              this.$Message.error(res.msg || '操作失败')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';

.mex-dim-hint {
  margin: 0 0 8px;
  color: #808695;
  line-height: 20px;
}

.mex-dim-card {
  background: #f8f8f9;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  padding: 8px 12px 0;

  .ivu-form-item {
    margin-bottom: 10px;
  }

  .ivu-form-item-label {
    padding: 0 0 4px;
    line-height: 18px;
    float: none;
  }

  .ivu-form-item-content {
    margin-left: 0 !important;
  }

  .ivu-input-number {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// MexSpeakQuestionList.vue?151bc334